<template>
  <div class="big-box">
    <navy-bar />
    <div class="main-box">
      <!-- <iframe
        src="https://www.youtube.com/embed/mQbI_H-0TQc"
        style="width:400px;height:300px;position:absolute; left:0px; top:0px"
      ></iframe> -->
      <!-- <div @click="aa">test</div> -->
      <div class="statement" @click="handleShowStatement">Statement</div>
      <img
        src="@/assets/images/bg_house_light.png"
        class="room-bg"
        alt="super solar calculator cabin"
        @click="handleLion"
      />

      <div class="tooltip-warp cabin-tooltip">
        <transition name="close-comingsoon">
          <div
            class="cabin-tooltip-content tooltip-content"
            v-if="!cabinComingsoon"
          >
            Cabin
          </div>
        </transition>
        <transition name="show-comingsoon">
          <div
            class="cabin-comingsoon-tooltip comingsoon-tooltip"
            v-if="cabinComingsoon"
          >
            <div class="comingsoon-content">
              <img src="@/assets/images/comingsoon.png" />
              <div style="font-size:16px;margin-top: 10px;">
                Coming soon. Stay tuned.
              </div>
              <div style="font-size:12px;margin-top: 2px;white-space: nowrap;">
                (RV scenario is ready. You can try it now.)
              </div>
            </div>
          </div>
        </transition>
        <div class="box-triangle"></div>
      </div>

      <!-- <img
        src="@/assets/images/bg_car.png"
        class="car-bg"
        alt="super solar calculator RV trailor van camper"
      /> -->
      <div class="car-bg">
        <img
          class="car-white-bg"
          src="@/assets/images/bg_car_white.png"
          alt="super solar calculator RV trailor van camper"
        />
        <img
          class="car-white-bg-active"
          src="@/assets/images/bg_car_white_active.png"
          alt="super solar calculator RV trailor van camper"
        />
      </div>
      <div class="tooltip-warp car-tooltip">
        <div class="car-tooltip-content tooltip-content">
          RV
        </div>
        <div class="box-triangle"></div>
      </div>
      <img
        src="@/assets/images/bg_ship_light.png"
        class="boat-bg"
        alt="super solar calculator yacht marine"
      />
      <div class="tooltip-warp boat-tooltip">
        <transition name="close-comingsoon">
          <div
            class="boat-tooltip-content tooltip-content"
            v-if="!boatComingsoon"
          >
            Yacht
          </div>
        </transition>
        <transition name="show-comingsoon">
          <div
            class="boat-comingsoon-tooltip comingsoon-tooltip"
            v-if="boatComingsoon"
          >
            <div class="comingsoon-content">
              <img src="@/assets/images/comingsoon.png" />
              <div style="font-size:16px;margin-top: 10px;">
                Coming soon. Stay tuned.
              </div>
              <div style="font-size:12px;margin-top: 2px;white-space: nowrap;">
                (RV scenario is ready. You can try it now.)
              </div>
            </div>
          </div>
        </transition>
        <div class="box-triangle"></div>
      </div>
      <!-- <div class="boat-bg-box">
        <div class="cabin-box-content">
          Yacht
          <div class="cabin-box-triangle"></div>
        </div>
      </div> -->
      <!-- <img src="@/assets/images/tree.png" class="tree">圣诞树  -->
      <!-- <img src="@/assets/images/merry_lion.png" class="merry-bg">狮子人  -->
      <div
        @mouseover="isShowHomeLionActive = true"
        @mouseleave="isShowHomeLionActive = false"
        class="cc"
      >
        <img src="@/assets/images/lion_active.png" class="home-lion" />
        <!-- <img
          src="@/assets/images/home-lion-active.png"
          class="home-lion-active"
          v-show="isShowHomeLionActive"
        /> -->
      </div>
      <div class="merry_lion-box">
        <div class="lion-box-content">
          Hi, I'm Renny. Welcome to Renogy Super Solar Calculator!<br />
          This Calculater is to help you quickly determine your power needs and
          genereate a solar plan.<br />
          <a href="https://www.youtube.com/watch?v=mQbI_H-0TQc" target="_blank"
            >Click me to watch the Tutorial Video.</a
          >
          Everyone can enjoy clean energy with ease and fun.
          <div class="lion-box-triangle"></div>
        </div>
      </div>
      <div class="qr-code">
        <div class="qr-code-box dis-flex">
          <!-- <div style="margin-bottom: 10px;">
                        <div>Learn more</div>
                        <div>about solar</div>
                    </div> -->
          <img src="@/assets/images/QR_code.png" alt="" />
        </div>
      </div>
      <div class="right-top-text">
        <!-- <div class="top-text">Super Solar Calculator</div>
                <div class="bottom-text">Calculate your needs, generate your plan</div> -->
        <img src="@/assets/images/name.png" style="max-width: 35vh;" />
      </div>

      <img
        src="@/assets/images/bg_house_active.png"
        class="room-bg-active"
        v-show="isShowRoomActive"
        alt="super solar calculator cabin"
      />

      <img
        src="@/assets/images/bg_car_active.png"
        class="car-bg-active"
        v-show="isShowCarActive"
        alt="super solar calculator RV trailor van camper"
      />
      <img
        src="@/assets/images/bg_ship_active.png"
        class="boat-bg-active"
        v-show="isShowBoatActive"
        alt="super solar calculator yacht marine"
      />
      <div
        class="home"
        data-sensors-click
        @mouseover="cabinComingsoon = true"
        @mouseleave="cabinComingsoon = false"
      ></div>
      <div data-sensors-click class="car" @click="jumpFirStep">
        <img src="@/assets/images/car_pointer.png" class="car-pointer" />
      </div>
      <div
        class="boat"
        data-sensors-click
        @mouseover="boatComingsoon = true"
        @mouseleave="boatComingsoon = false"
      ></div>
      <!-- <div class="dis-flex text">
                <span @click="jumpFirStep">Create Plan</span>
                <span @click="jumpMyPlan">My Plan</span>
                <span @click="showStatement = true;">Statement</span>
            </div> -->
      <ul class="clearfix navy">
        <li data-sensors-click @click="goToYoutube">
          <img src="@/assets/images/tutorialVideo.png" />
          <div class="state font-bolder">Tutorial Video</div>
        </li>
        <li data-sensors-click @click="jumpFirStep">
          <img src="@/assets/images/RV.png" />
          <div class="state font-bolder">RV</div>
        </li>
        <!-- <li @click="comingSoon = true;"> -->
        <li data-sensors-click @click="jumpMyPlan">
          <img src="@/assets/images/MyPlan.png" />
          <div class="state font-bolder">My Plan</div>
        </li>
        <li data-sensors-click>
          <div class="dis-flex align-items like-box" @click="handleLike">
            <img src="@/assets/images/home-hand-active.png" v-if="isLike" />
            <img src="@/assets/images/home-hand.png" v-else />
            <div class="count" :class="{ active: isLike }">
              {{ count | countFilter }}
            </div>
          </div>
          <div class="state font-bolder">Like</div>
        </li>
      </ul>
    </div>
    <!-- statement -->
    <Modal
      v-model="showStatement"
      :footer-hide="true"
      :closable="false"
      width="800"
      class-name="vertical-center-modal"
    >
      <div class="tipsModal-box">
        <div class="tipsModal-title font-bolder" style="margin-bottom: 20px;">
          Responsibility Statement and Disclaimer
        </div>
        <div class="tipsModal-content">
          <p>
            The Super Solar Calculator provided by Renogy is for your
            convenience and should be used as a reference only. It is an
            interactive tool that provides general information without
            considering your particular circumstances.
          </p>
          <p>
            The results generated by the Super Solar Calculator recommend Renogy
            products which might be suitable to your needs based upon the data
            entered by you. It is important to remember that an assessment as to
            which product(s) may be best suited to your needs is likely to
            depend upon other specific factors not taken into account by the
            Super Solar Calculator, including but not limited to the type, size,
            and features of your vehicle and towing unit, the features and
            specifications of the particular appliances that you wish to power
            and your patterns of usage of such appliances, etc.
          </p>
          <p>
            The results generated by the Super Solar Calculator are indicative
            only, do not constitute advice, and should not be relied upon as
            being final and accurate. You must decide at your own risk whether
            the suggested Renogy products are suitable for your circumstances.
          </p>
          <p>
            Renogy does not guarantee or warrant that the information and
            results generated by the Super Solar Calculator are accurate or
            error-free and does not accept any responsibility for any loss
            suffered or incurred by you as a result of your reliance on the
            information or results generated by the Super Solar Calculator.
          </p>
          <p>
            Your use of the Super Solar Calculator is subject to the above
            Responsibility Statement and Disclaimer.
          </p>
          <p>
            By clicking on the icon marked "Accept" you confirm that you have
            read, understood, and agreed to the above Responsibility Statement
            and Disclaimer.
          </p>
        </div>
        <div class="tipsModal-button dis-flex">
          <div style="cursor: pointer;" @click="handleCancelState">Cancel</div>
          <div style="cursor: pointer;" @click="handleAccept">Accept</div>
        </div>
      </div>
    </Modal>
    <Modal
      v-model="comingSoon"
      :footer-hide="true"
      :closable="false"
      class-name="vertical-center-modal"
      width="600"
    >
      <div class="tipsModal-box">
        <div class="tipsModal-title">
          Coming soon. Stay tuned.<br />(RV scenario is ready. You can try it
          now.)
        </div>
      </div>
    </Modal>
    <Modal
      v-model="isShowContinue"
      :footer-hide="true"
      :closable="false"
      class-name="vertical-center-modal"
      width="600"
    >
      <div class="tipsModal-box">
        <div class="tipsModal-content">
          <div class="tipsModal-title">
            Do you want to continue your work or start from scratch?
          </div>
        </div>
        <div class="tipsModal-button dis-flex">
          <div style="cursor: pointer;" @click="handleContinue">Continue</div>
          <div style="cursor: pointer;" @click="handleRestart">Restart</div>
        </div>
      </div>
    </Modal>
    <!-- 登录弹窗 -->
    <Modal
      v-model="showLogin"
      :footer-hide="true"
      :closable="false"
      :mask-closable="false"
      width="40"
      class-name="vertical-center-modal"
    >
      <div>
        <login-modal @handleClose="closeFun" @loginSuccess="listenLogin" />
      </div>
    </Modal>
    <!-- 常规音乐 -->
    <!-- <regular-music /> -->
  </div>
</template>

<script>
import { showLoading, closeLoading } from "@/js/lib/utils";
import { dealCode } from "@/js/lib/dealCode";
import NavyBar from "@/components/navyBar/NavyBar.vue";
import RegularMusic from "@/components/regularMusic/RegularMusic.vue";
import LoginModal from "@/components/loginModal/LoginModal.vue";
import $ from "jquery";

export default {
  components: {
    NavyBar,
    RegularMusic,
    LoginModal
  },
  data() {
    return {
      uuid: "",
      cabinComingsoon: false,
      boatComingsoon: false,
      showStatement: false,
      comingSoon: false,
      accept: "",
      isClickCar: false,
      isShowContinue: false,
      planId: "",
      isShowRoomActive: false,
      isShowCarActive: false,
      isShowBoatActive: false,
      count: 0,
      isLike: 0,
      showLogin: false,
      isShowHomeLionActive: false,
      isToMyPlay: false
    };
  },
  filters: {
    countFilter(val) {
      let data = 0;
      if (val > 999999) {
        data = "999K+";
      } else {
        val += "";
        let reg = /(?=(\B)(\d{3})+$)/g;
        data = val.replace(reg, ",");
      }
      return data;
    }
  },
  async mounted() {
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
    if (isMobile) {
      return;
    }
    let deviceType = this.deviceType();
    // console.log(deviceType)
    gtag("event", "device_type", {
      send_to: "G-VVXR7PJV6C",
      device_type: deviceType
    });
    /*
            let location = window.location.search;
            if(location.indexOf('bc-us') > -1) {
                gtag('event', 'source', {
                    'send_to': 'G-VVXR7PJV6C',
                    'source': "https://super-solar-calculator.renogy-dchome.com/?from=bc-us#/home"
                });
            }else if(location.indexOf('pc_forum') > -1) {
                gtag('event', 'source', {
                    'send_to': 'G-VVXR7PJV6C',
                    'source': "https://super-solar-calculator.renogy-dchome.com/?from=pc_forum#/home"
                });
            }else {
                gtag('event', 'source', {
                    'send_to': 'G-VVXR7PJV6C',
                    'source': "https://super-solar-calculator.renogy-dchome.com"
                });
            }
            */
    let source = window.location.href;
    if (source.indexOf("_end") > -1) {
      let arr = source.split("_end");
      source = arr[0] + "_end";
    }
    sessionStorage.setItem("source", source);
    gtag("event", "source", {
      send_to: "G-VVXR7PJV6C",
      source: source
    });
    // window.jsonpCallback = (data) => {
    //     console.log(data, 3333333333)
    // }
    this.uuid = localStorage.getItem("uuid");
    this.accept = localStorage.getItem("accept");
    this.planId = localStorage.getItem("planId");
    if (this.accept != 1) {
      this.showStatement = true;
    }
    if (!localStorage.getItem("token")) {
      if (!this.uuid) {
        this.getUserToken();
      } else {
        this.refreshToken();
      }
    } else {
      this.getLikeInfo();
    }
    /*
            // 处理社区登录跳转逻辑
            let userToken = localStorage.getItem('userToken');
            if(!userToken) {//未登录
                // let tokenCookie = document.cookie;
                let cookie = '';
                if(document.cookie) {
                    let arr = document.cookie.split('; ');
                    arr.map(e => {
                        if(e.indexOf('renogy-pc-token=') > -1) {
                            cookie = e;
                        }
                    })
                }
                if(cookie) {//有cookie
                    let temp = cookie.replace('renogy-pc-token=', '')
                    localStorage.setItem('userToken', temp);
                    let userInfo = await this.getUserInfo(temp);
                    localStorage.setItem('userInfo', JSON.stringify(userInfo));
                    let data = await this.handleBind(userInfo.userInnerId);

                }
            }
            */
  },
  methods: {
    goToYoutube() {
      window.open("https://www.youtube.com/watch?v=mQbI_H-0TQc");
    },
    closeFun() {
      this.isToMyPlay = false;
      this.showLogin = false;
    },
    handleBind(id) {
      return new Promise((resolve, reject) => {
        this.$http
          .post(API.bindUserId, {
            userId: id,
            userinfo: localStorage.getItem("userInfo") || "{}"
          })
          .then(res => {
            dealCode({
              code: res.data.code,
              successCallback: async () => {
                resolve(true);
              },
              errorDeal: () => {
                reject(true);
              }
            });
          });
      });
    },
    getUserInfo(token) {
      return new Promise((resolve, reject) => {
        this.$http
          .post(API.getLoginInfo, {
            token: token
          })
          .then(res => {
            dealCode({
              code: res.data.code,
              successCallback: async () => {
                let result = res.data.data;
                resolve(result.data);
              },
              errorDeal: () => {
                reject(true);
              }
            });
          });
      });
    },
    deviceType() {
      let ua = navigator.userAgent;
      let isWindowsPhone = /(?:Windows Phone)/.test(ua),
        isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
        isAndroid = /(?:Android)/.test(ua),
        isFireFox = /(?:Firefox)/.test(ua),
        isChrome = /(?:Chrome|CriOS)/.test(ua),
        isTablet =
          /(?:iPad|PlayBook)/.test(ua) ||
          (isAndroid && !/(?:Mobile)/.test(ua)) ||
          (isFireFox && /(?:Tablet)/.test(ua)),
        isPhone = /(?:iPhone)/.test(ua) && !isTablet,
        isPc = !isPhone && !isAndroid && !isSymbian;
      let os = {
        isTablet: isTablet,
        isPhone: isPhone,
        isAndroid: isAndroid,
        isPc: isPc
      };
      if (os.isAndroid || os.isPhone) {
        return "mobile";
      } else if (os.isTablet) {
        return "ipad";
      } else if (os.isPc) {
        return "pc";
      }
    },
    handleLion() {
      gtag("event", "click_renny", {
        send_to: "G-VVXR7PJV6C",
        click_renny: "1"
      });
    },
    handleBoat() {
      gtag("event", "click_yacht", {
        send_to: "G-VVXR7PJV6C",
        click_yacht: "1"
      });
      this.comingSoon = true;
    },
    listenLogin(e) {
      localStorage.setItem("userToken", e);
      if (this.isToMyPlay) {
        this.$router.push({ name: "myPlan" });
      } else {
        window.location.reload();
      }
    },
    handleLike() {
      let userToken = localStorage.getItem("userToken");
      if (userToken) {
        if (!this.isLike) {
          //点赞
          this.$http.post(API.likes, {}).then(res => {
            dealCode({
              code: res.data.code,
              successCallback: async () => {
                this.isLike = 1;
                this.count++;
              }
            });
          });
        }
      } else {
        console.log("???");
        // localStorage.clear();
        // this.$router.push({
        //   name: "Login"
        // });
        // window.location.href = "/login";
        // console.log("???");
        // this.showLogin = true;

        window.location.assign(
          `https://account.renogy.com/login?callback=${encodeURIComponent(
            window.location.href
          )}&isSelfDeveloped=true&store=US&locale=en_US&platform=calculator`
        );
      }
    },
    getLikeInfo() {
      this.$http.post(API.likesCount, {}).then(res => {
        dealCode({
          code: res.data.code,
          successCallback: async () => {
            let result = res.data.data;
            this.count = result.count;
            this.isLike = result.likes;
            // 处理社区登录跳转逻辑
            let userToken = localStorage.getItem("userToken");
            if (!userToken) {
              //未登录
              // let tokenCookie = document.cookie;
              let cookie = "";
              if (document.cookie) {
                let arr = document.cookie.split("; ");
                arr.map(e => {
                  if (e.indexOf("renogy-pc-token=") > -1) {
                    cookie = e;
                  }
                });
              }
              if (cookie) {
                //有cookie
                let temp = cookie.replace("renogy-pc-token=", "");
                localStorage.setItem("userToken", temp);
                let userInfo = await this.getUserInfo(temp);
                localStorage.setItem("userInfo", JSON.stringify(userInfo));
                let data = await this.handleBind(userInfo.userInnerId);
              }
            }
          }
        });
      });
    },
    handleHome() {
      this.comingSoon = true;
      gtag("event", "click_cabin", {
        send_to: "G-VVXR7PJV6C",
        click_cabin: "1"
      });
    },
    aa() {
      var arr = [
        // 'https://www.renogy.com/cart.php?action=add&product_id=1566&qty=1&sku=RNG-INVT-3000-12V-P2-US&callbackParam=jsonpCallback',
        // 'https://www.renogy.com/cart.php?action=add&product_id=1356&qty=1&sku=RNG-BATT-LFP-12-170-US&callbackParam=jsonpCallback',
        // 'https://www.renogy.com/cart.php?action=add&product_id=1692&qty=1&sku=RNG-175DB-H-US&callbackParam=jsonpCallback'
        {
          product_id: 1566,
          qty: 1,
          sku: "RNG-INVT-3000-12V-P2-US"
        },
        {
          product_id: 1356,
          qty: 1,
          sku: "RNG-BATT-LFP-12-170-US"
        },
        {
          product_id: 1692,
          qty: 1,
          sku: "RNG-175DB-H-US"
        }
      ];
      let time = 0;
      arr.map((e, v) => {
        console.log(time, v);
        setTimeout(async () => {
          var m = await this.saveCar(
            e.product_id,
            e.qty,
            e.sku,
            v,
            arr.length - 1
          );
          // $("head").append(`<script src='https://www.renogy.com/cart.php?product_id=${e.product_id}&qty=${e.qty}&sku=${e.sku}'><\/script>`);
          // $.ajax({
          //     type: "get",
          //     async: false,
          //     url: `https://www.renogy.com/cart.php?product_id=${e.product_id}&qty=${e.qty}&sku=${e.sku}`,
          //     dataType: "jsonp",
          //     jsonp: "jsonpCallback", //传递给请求处理程序或页面的，用以获得jsonp回调函数名的参数名(默认为:callback)
          //     jsonpCallback: "success_jsonpCallback", //自定义的jsonp回调函数名称，默认为jQuery自动生成的随机函数名
          //     success: function(json) {},
          //     error: function() {}
          // });
          if (v == arr.length - 1) {
            let time = setTimeout(() => {
              top.location.href = "https://www.renogy.com/cart.php";
            }, time + 500);
          }
        }, time);
        time += 1000;
      });
    },
    saveCar(productId, qty, sku, v, l) {
      return new Promise((resolve, reject) => {
        this.$jsonp("https://www.renogy.com/cart.php", {
          callbackQuery: "callbackParam",
          callbackName: "jsonpCallback",
          action: "add",
          product_id: productId,
          qty: qty,
          sku: sku
        })
          .then(json => {
            // 返回的jsonp数据不会放这里，而是在 window.jsonpCallback
          })
          .catch(e => {
            if (v == l) {
              top.location.href = "https://www.renogy.com/cart.php";
            }
          });
      });
    },
    handleCancelState() {
      showLoading();
      this.$http.post(API.cancelAccept, {}).then(res => {
        dealCode({
          code: res.data.code,
          successCallback: async () => {
            this.accept = 0;
            localStorage.setItem("accept", 0);
            this.showStatement = false;
            closeLoading();
          },
          errorDeal: () => {
            this.$Message.error("Invalid Operation.");
            closeLoading();
          },
          completeDeal: () => {
            closeLoading();
          }
        });
      });
    },
    jumpFirStep() {
      this.isClickCar = true;
      if (this.accept == 1) {
        if (this.planId) {
          this.isShowContinue = true;
        } else {
          this.createPlan();
        }
      } else {
        this.showStatement = true;
      }
    },
    // 继续上次操作
    handleContinue() {
      let current = localStorage.getItem("current");
      if (current == 1) {
        this.$router.push({
          name: "FirstStep",
          query: {
            planId: this.planId
          }
        });
      } else {
        this.$router.push({
          name: "SecondStep",
          query: {
            planId: this.planId,
            isContinue: "1"
          }
        });
      }
    },
    // 重新开始
    handleRestart() {
      this.createPlan();
    },
    createPlan() {
      showLoading();
      this.$http.post(API.planAdd, {}).then(res => {
        dealCode({
          code: res.data.code,
          successCallback: async () => {
            localStorage.removeItem("current");
            localStorage.removeItem("status");
            localStorage.removeItem("step");
            localStorage.removeItem("issolarpanelJump");
            localStorage.removeItem("isforrbbidJump");
            localStorage.removeItem("isChargeControllJump");
            // console.log(this.$route);
            // this.$router.return;
            // return;
            // this.$router.push({
            //   name: "FirstStep",
            //   query: {
            //     planId: res.data.data.plan_id
            //   }
            // path: `/firstStep?planId=${res.data.data.plan_id}`
            // });
            closeLoading();
            const protocol = window.location.protocol;
            const host = window.location.host;
            window.location.href = `${protocol}//${host}/#/firstStep?planId=${res.data.data.plan_id}`;
          },
          errorDeal: () => {
            closeLoading();
            this.$Message.error("Invalid Operation.");
          },
          completeDeal: () => {
            closeLoading();
          }
        });
      });
    },
    jumpMyPlan() {
      let userToken = localStorage.getItem("userToken");
      if (userToken) {
        this.$router.push({ name: "myPlan" });
      } else {
        this.isToMyPlay = true;
        // this.showLogin = true;
        // localStorage.clear();
        // this.$router.push({
        //   name: "Login"
        // });
        window.location.assign(
          `https://account.renogy.com/login?callback=${encodeURIComponent(
            window.location.href
          )}&isSelfDeveloped=true&store=US&locale=en_US&platform=calculator`
        );
      }
    },
    getUserToken() {
      this.$http.post(API.register, {}).then(res => {
        dealCode({
          code: res.data.code,
          successCallback: async () => {
            let data = res.data.data;
            localStorage.setItem("token", data.token);
            localStorage.setItem("uuid", data.uuid);
            localStorage.setItem("accept", data.accept);
            this.accept = data.accept;
            this.getLikeInfo();
          },
          errorDeal: () => {
            this.$Message.error("Invalid Operation.");
          }
        });
      });
    },
    refreshToken() {
      this.$http
        .post(API.getTokenByUuid, {
          uuid: this.uuid
        })
        .then(res => {
          dealCode({
            code: res.data.code,
            successCallback: async () => {
              let data = res.data.data;
              localStorage.setItem("token", data.token);
              localStorage.setItem("accept", data.accept);
              this.accept = data.accept;
              this.getLikeInfo();
            },
            errorDeal: () => {
              this.$Message.error("Invalid Operation.");
            }
          });
        });
    },
    handleShowStatement() {
      this.showStatement = true;
      this.isClickCar = false;
    },
    handleAccept() {
      this.$http.post(API.saveAccept, {}).then(res => {
        dealCode({
          code: res.data.code,
          successCallback: async () => {
            this.accept = 1;
            localStorage.setItem("accept", 1);
            this.showStatement = false;
            if (this.isClickCar) {
              this.createPlan();
            }
          },
          errorDeal: () => {
            this.$Message.error("Invalid Operation.");
          }
        });
      });
    }
  }
};
</script>

<style>
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}
.vertical-center-modal .ivu-modal {
  top: 0;
}
</style>
<style lang="scss" scoped type="text/css">
.tooltip-warp {
  width: 400px;
  position: absolute;
  height: 120px;
  z-index: 996;
}
.tooltip-content {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  background: rgba(17, 17, 17, 0.7);
  color: #fff;
  text-align: center;
  border-radius: 8px;
  font-weight: 600;
  z-index: 998;
  cursor: default;
  overflow: hidden;
}
.comingsoon-tooltip {
  position: absolute;
  overflow: hidden;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  border-radius: 8px;
  z-index: 998;
  background: rgba(17, 17, 17, 0.7);
  .comingsoon-content {
    display: flex;
    color: #fff;
    font-weight: 600;
    height: 100%;
    width: 100%;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
}

.car-tooltip {
  top: 4%;
  left: 50%;
}
.car-tooltip-content {
  width: 44px;
  height: 40px;
  line-height: 40px;
}
.boat-tooltip {
  top: 65%;
  left: 26%;
}
.boat-tooltip-content {
  width: 92px;
  height: 52px;
  line-height: 52px;
}
.boat-comingsoon-tooltip {
  width: 274px;
  height: 110px;
}
.cabin-tooltip {
  left: 18%;
  top: 15%;
}
.cabin-tooltip-content {
  width: 92px;
  height: 52px;
  line-height: 52px;
}
.cabin-comingsoon-tooltip {
  width: 274px;
  height: 110px;
}
.close-comingsoon-enter-active {
  animation: cabin-tip-out 0.5s linear;
}
.close-comingsoon-leave-active {
  animation: cabin-tip-out 0.3s linear reverse;
}
@keyframes cabin-tip-out {
  from {
    color: transparent;
    background-color: transparent;
    width: 274px;
    height: 110px;
  }
  to {
    width: 92px;
    height: 52px;
  }
}
.show-comingsoon-enter-active {
  animation: cabin-tip-in 0.5s;
  .comingsoon-content {
    animation: cabin-text-in 0.5s linear;
  }
}
.show-comingsoon-leave-active {
  animation: cabin-tip-in 0.3s reverse;
  .comingsoon-content {
    animation: cabin-text-in 0.3s reverse;
  }
}

@keyframes cabin-text-in {
  from {
    position: absolute;
    right: -200px;
    width: 274px;
  }
  to {
    right: 0;
    position: absolute;
  }
}
@keyframes cabin-tip-in {
  from {
    width: 92px;
    height: 52px;
    background-color: transparent;
  }
  to {
    width: 274px;
    height: 110px;
  }
}

.cabin-box-content {
  position: relative;
  font-size: 1.5vh;
  width: 100%;
  height: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  flex-direction: column;
}
.box-triangle {
  position: absolute;
  bottom: -8px;
  left: 50%;
  border-width: 8px 8px 0;
  border-color: transparent;
  border-style: solid;
  border-top-color: rgba(17, 17, 17, 0.7);
  transform: translateX(-50%);
}

.not-oline-tips {
  padding: 8px 15px;
  position: absolute;
  background-color: #fff;
  height: auto;
  text-align: center;
  font-size: 14px;
  width: fit-content;
  border-radius: 10px;
  .tip-trangle {
    position: absolute;
    top: -15px;
    left: 50%;
    border-width: 8px;
    border-color: transparent;
    border-style: solid;
    transform: translateX(-50%);
  }
}

.room-tips {
  top: 30%;
  left: 25%;
  .tip-trangle {
    border-bottom-color: #fff;
  }
}
.boat-tips {
  bottom: 5%;
  left: 20%;
  .tip-trangle {
    border-bottom-color: #fff;
  }
}
.big-box {
  height: 100vh;
  // .room-bg {
  //     position: absolute;
  //     top: 0%;
  //     left: 18%;
  //     width: 25%;
  //     height: auto;
  // }
  .room-bg {
    position: absolute;
    top: 13%;
    left: 20%;
    width: 21%;
    height: auto;
  }
  .cabin-box {
    position: absolute;
    bottom: 79%;
    right: 63%;
    width: 86px;
    height: 48px;
    background: rgba(1, 1, 1, 0.7);
    color: #fff;
    // padding: 16px 22px;
    border-radius: 8px;
    z-index: 998;
    cursor: default;
  }
  .cabin-comingsoon-box {
    position: absolute;
    bottom: 79%;
    right: calc(63% - 94px);
    width: 274px;
    height: 110px;
    background: rgba(1, 1, 1, 0.7);
    color: #fff;
    border-radius: 8px;
    z-index: 998;
    cursor: default;
  }
  .room-bg-active {
    position: absolute;
    top: 4%;
    left: 18%;
    width: 25%;
    height: auto;
  }
  .car-bg {
    position: absolute;
    top: 8%;
    left: 48%;
    width: 18.5vw;
    height: 14.5vw;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    // animation: change-bg 1s steps(1, start) infinite alternate;
    .car-white-bg {
      width: 100%;
      position: absolute;
      z-index: 11;
      // animation: show-car 1s steps(0, start) infinite alternate;
    }
    .car-white-bg-active {
      position: absolute;
      left: -1.3vw;
      top: -0.6vw;
      width: 110%;
      animation: show-car 1s linear 1s infinite alternate;
    }
  }
  @keyframes show-car {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  .car-bg-box {
    position: absolute;
    top: 15%;
    left: 62%;
    background: rgba(1, 1, 1, 0.7);
    color: #fff;
    border-radius: 8px;
    z-index: 999;
    cursor: default;
  }
  .car-bg-active {
    position: absolute;
    top: 4%;
    left: 47%;
    width: 21%;
    height: auto;
  }
  .boat-bg {
    position: absolute;
    bottom: -1%;
    left: 18%;
    width: 40%;
    height: auto;
  }
  .boat-bg-box {
    position: absolute;
    top: 71%;
    left: 36%;
    background: rgba(1, 1, 1, 0.7);
    color: #fff;
    border-radius: 8px;
    z-index: 999;
    cursor: default;
  }
  .merry-bg {
    cursor: pointer;
    position: absolute;
    top: 27%;
    left: 42%;
    max-width: 7vh;
    height: auto;
  }
  .cc:hover + .merry_lion-box {
    display: block;
  }
  .home-lion {
    cursor: pointer;
    position: absolute;
    top: 30%;
    left: 42%;
    width: 7.5vw;
    height: auto;
  }
  .home-lion-active {
    cursor: pointer;
    position: absolute;
    max-width: 8vh;
    height: auto;
    top: 23%;
    left: 41.7%;
  }
  .home-lion:hover + .merry_lion-box {
    display: block;
  }
  .tree {
    position: absolute;
    top: 31%;
    left: 13.8%;
    max-width: 30vh;
    height: auto;
  }
  .merry_lion-box {
    display: none;
    position: absolute;
    top: 34%;
    left: 45.4%;
    background: rgba(17, 17, 17, 0.7);
    color: #fff;
    font-size: 12px;
    border-radius: 10px;
    z-index: 999;
    transform: translate(-50%, -100%);
    cursor: default;
    &:hover {
      display: block;
    }
    .lion-box-content {
      width: 280px;
      position: relative;
      padding: 10px;
      box-sizing: border-box;
      a {
        color: #56ccf2;
      }
      .lion-box-triangle {
        position: absolute;
        bottom: -8px;
        left: 50%;
        border-width: 8px 8px 0;
        border-color: transparent;
        border-style: solid;
        border-top-color: rgba(17, 17, 17, 0.7);
        transform: translateX(-50%);
      }
    }
  }
  .qr-code {
    position: absolute;
    bottom: 8%;
    left: 4%;
    .qr-code-box {
      flex-direction: column;
      align-items: center;
      div {
        font-size: 1.6vh;
        color: #a9a9a9;
      }
      img {
        max-width: 100%;
        height: auto;
      }
    }
  }
  .right-top-text {
    position: absolute;
    top: 6%;
    left: 4%;
    .top-text {
      font-size: 3.1vh;
      font-weight: bold;
      color: #fffefe;
      margin-bottom: 4px;
    }
    .bottom-text {
      font-size: 1.6vh;
      color: #fffefe;
      opacity: 0.6;
    }
  }
  .boat-bg-active {
    position: absolute;
    bottom: 5%;
    left: 19%;
    width: 32%;
    height: auto;
  }
  .main-box {
    height: calc(100vh - 0px);
    overflow: hidden;
    // background-size: 100% 100%;
    // background: url('http://guangfu-1300435598.cos.ap-guangzhou.myqcloud.com/renogyCalculator/20211029/20211029583hnu.png') no-repeat center center fixed;
    // background: url('https://guangfu-1300435598.cos.ap-guangzhou.myqcloud.com/renogyCalculator/bg.png') no-repeat center center fixed;
    background: url("~@/assets/images/bg.png") no-repeat center center fixed;
    // background: url('~@/assets/images/bg_merry.jpg') no-repeat center center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    position: relative;
    .statement {
      position: absolute;
      top: 6%;
      right: 6%;
      width: 24vh;
      height: 3vw;
      line-height: 3vw;
      text-align: center;
      background-color: #c7c7c7;
      border-radius: 10px;
      cursor: pointer;
    }
    .home {
      position: absolute;
      top: 11%;
      left: 22%;
      width: 31vh;
      height: 10vw;
      z-index: 999;
      transform: rotate(30deg);
      cursor: pointer;
    }
    .car {
      position: absolute;
      top: 12%;
      left: 49%;
      width: 33vh;
      height: 10vw;
      transform: rotate(30deg);
      z-index: 12;
      cursor: pointer;
      .car-pointer {
        position: absolute;
        bottom: 0;
        right: 60px;
        width: 1.8vw;
        height: auto;
        z-index: 20;
        // animation: name duration timing-function delay iteration-count direction fill-mode;
        animation: pointer-scale 1s ease infinite alternate;
      }
      @keyframes pointer-scale {
        0% {
          transform: scale(1) rotate(-30deg);
        }
        // 20% {
        //   transform: scale(1.1) rotate(-30deg);
        // }
        95% {
          transform: scale(1.3) rotate(-30deg);
        }
        100% {
          transform: scale(1.3) rotate(-30deg);
        }
        // from {
        //   transform: scale(1) rotate(-30deg);
        // }
        // to {
        //   transform: scale(1.3) rotate(-30deg);
        // }
      }
    }
    .boat {
      position: absolute;
      bottom: 4%;
      left: 19%;
      width: 40vw;
      height: 10vw;
      z-index: 999;
      transform: rotate(10deg);
      cursor: pointer;
    }
    .navy {
      position: absolute;
      bottom: 9%;
      right: 6%;
      display: flex;
      li {
        cursor: pointer;
        text-align: center;
        > img {
          display: inline-block;
          width: 8vh;
          height: 8vh;
          border-radius: 100%;
        }
        .state {
          color: #fff;
          text-align: center;
          padding: 5px 0;
          font-size: 12px;
          font-weight: bold;
        }
        &:not(:last-child) {
          margin-right: 20px;
        }
        .like-box {
          width: 8vh;
          height: 8vh;
          border-radius: 100%;
          background-color: #00c0e9;
          flex-direction: column;
          justify-content: center;
          img {
            max-width: 50%;
            height: auto;
          }
          .count {
            font-size: 12px;
            text-align: center;
            color: #1d768a;
            &.active {
              color: #fff;
            }
          }
        }
      }
    }
  }
}
// .text {
//     width: 1075px;
//     margin: 200px auto 0;
//     text-align: center;
//     justify-content: space-between;
//     span {
//         display: block;
//         width: 310px;
//         height: 50px;
//         line-height: 50px;
//         background: #1A9AA4;
//         color: #fff;
//         font-size: 18px;
//         font-weight: 600;
//         border-radius: 10px;
//         cursor: pointer;
//     }
// }
//按钮弹窗
.tipsModal-box {
  padding: 20px 80px;
  // min-height: 20vh;
  .tipsModal-title {
    text-align: center;
    color: #2b2b2b;
    font-size: 14px;
    font-weight: bold;
    // margin-bottom: 20px;
  }
  .tipsModal-content {
    font-size: 12px;
    color: #2b2b2b;
    margin-bottom: 20px;
    p {
      padding-bottom: 10px;
    }
  }
  .tipsModal-button {
    max-width: 600px;
    margin: 0 auto;
    justify-content: space-between;
    > div {
      width: 45%;
      background: linear-gradient(0deg, #4d4d4d 0%, #727272 100%);
      box-shadow: 0px -2px 4px 0px rgba(98, 98, 98, 0.76);
      font-size: 20px;
      text-align: center;
      border-radius: 10px;
      color: #fff;
      padding: 10px 0;
    }
    > div:hover {
      background: linear-gradient(0deg, #189ebd 0%, #17c0e7 100%);
      box-shadow: 0px -2px 3px 0px rgba(29, 181, 217, 0.74);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/home/Home.vue